import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import classnames from 'classnames';

import Rate from '../Rate/Rate';

import { getGrade } from '../../actions/comment';
import styles from './DetailScore.module.less';

const selectGrade = createSelector(
  state => state.comment,
  comment => comment.grade,
);

export default memo(({ appDetailsData }) => {
  const dispatch = useDispatch();
  const gradeInfo = useSelector(selectGrade);

  const [bizIdentity, setBizIdentity] = useState('');

  useEffect(() => {
    const bizIdentityStr =
      appDetailsData.androidType === '1' ? appDetailsData.packageName : appDetailsData.softID;
    setBizIdentity(bizIdentityStr);
  }, []);

  useEffect(() => {
    if (!gradeInfo || !gradeInfo.bizIdentity || gradeInfo.bizIdentity !== bizIdentity) {
      if (bizIdentity) {
        dispatch(
          getGrade({
            bizIdentity,
          }),
        );
      }
    }
  }, [dispatch, gradeInfo, bizIdentity]);

  return gradeInfo && gradeInfo.bizIdentity === bizIdentity ? (
    <div className={styles.detail_score}>
      <div className={styles.score_info}>
        <div className={styles.score_info_left}>
          <div className={styles.left_line_one}>
            <span className={styles.left_line_one_score_num}>{gradeInfo.averageStar}</span>分
          </div>
          <div className={styles.left_line_two}>
            <Rate score={gradeInfo.averageStar} />
          </div>
          <div className={styles.left_line_three}>{gradeInfo.commentUserCount}人已评分</div>
        </div>
        <div className={styles.score_info_right}>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 ${parseInt(
                  (gradeInfo.numberOfFiveStars / gradeInfo.commentUserCount) * 100,
                  10,
                )}%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>
              {gradeInfo.commentUserCount !== 0
                ? `${parseInt(
                    (gradeInfo.numberOfFiveStars / gradeInfo.commentUserCount) * 100,
                    10,
                  )}%`
                : `0%`}
            </div>
          </div>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 ${parseInt(
                  (gradeInfo.numberOfFourStars / gradeInfo.commentUserCount) * 100,
                  10,
                )}%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>
              {gradeInfo.commentUserCount !== 0
                ? `${parseInt(
                    (gradeInfo.numberOfFourStars / gradeInfo.commentUserCount) * 100,
                    10,
                  )}%`
                : `0%`}
            </div>
          </div>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 ${parseInt(
                  (gradeInfo.numberOfThreeStars / gradeInfo.commentUserCount) * 100,
                  10,
                )}%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>
              {gradeInfo.commentUserCount !== 0
                ? `${parseInt(
                    (gradeInfo.numberOfThreeStars / gradeInfo.commentUserCount) * 100,
                    10,
                  )}%`
                : `0%`}
            </div>
          </div>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 ${parseInt(
                  (gradeInfo.numberOfTwoStars / gradeInfo.commentUserCount) * 100,
                  10,
                )}%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>
              {gradeInfo.commentUserCount !== 0
                ? `${parseInt(
                    (gradeInfo.numberOfTwoStars / gradeInfo.commentUserCount) * 100,
                    10,
                  )}%`
                : `0%`}
            </div>
          </div>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 ${parseInt(
                  (gradeInfo.numberOfOneStar / gradeInfo.commentUserCount) * 100,
                  10,
                )}%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>
              {gradeInfo.commentUserCount !== 0
                ? `${parseInt((gradeInfo.numberOfOneStar / gradeInfo.commentUserCount) * 100, 10)}%`
                : `0%`}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className={styles.detail_score}>
      <div className={styles.score_info}>
        <div className={styles.score_info_left}>
          <div className={styles.left_line_one}>
            <span className={styles.left_line_one_score_num}>{gradeInfo.averageStar || 0}</span>分
          </div>
          <div className={styles.left_line_two}>
            <Rate score={gradeInfo.averageStar} />
          </div>
          <div className={styles.left_line_three}>{gradeInfo.commentUserCount || 0}人已评分</div>
        </div>
        <div className={styles.score_info_right}>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 0%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>0%</div>
          </div>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 0%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>0%</div>
          </div>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 100%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>100%</div>
          </div>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 0%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>0%</div>
          </div>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 0%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>0%</div>
          </div>
        </div>
      </div>
    </div>
  );
});
